<template>
  <div id="app">
    <router-view />
    <!-- This is where your routed components (Home, Dashboard) will be displayed -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
#app {
  text-align: left;
  margin-top: 10px;
}
</style>
